/**
 * 状态类：status { success、error、warn }
 * 弹窗类：dialog { toast、alert、confirm }
 * 表单类：from { placeholder、label }
 * 表格类：table { }
 *
 * 接口请求类：request
 * 接口响应类：responce
 *
 * 页面模块类：
 *
 */

// 使用 {{$t('purchase.periods')}}  //第*期

// 状态
const state = {
  preheatIng: "預熱中",
  purchaseIng: "搶購中",
  process: "助力中",
  over: "已結束",
  finish: "已完成",
  noData: "暫無數據",
};

//抢购区和个人抢购记录页上方的subheader
const subheader = {
  pricePromise: "價格擔保，絕不破發",
  vipPrice: "VIP返利，價格優惠",
  protection: "獨家法幣本位保價",
  pricePromiseVal: "[*]天保價，絕不破發",
  rewards: "[*]%收益，承諾保價",
  vipDis: "VIP折扣，搶到賺到",
  zlz: "助力中",
};

// 抢购区
const purchase = {
  periods: "第[*]期",
  timesSheaves: "第[*]輪",
  supportPic: "[*]天保價，絕不破發",
  earnings: "[*]%收益，承諾保價",
  vipDiscount: "VIP折扣，搶到賺到",
  limit: "本輪額度",
  timeLimit: "限時價格",
  schedule: "當前進度",
  finishHalf: "已完成[*]%",
  subscriptionNum: "搶購數量",
  vipText: "（VIP[*]）享購買（[**] [***] [****]折）優惠",
  supportType:
    "保價管道：在保價期內，BiKing將以最低保價價格在次級市場掛入買單，用戶可選擇是否在保價期內賣出，保價期結束後，相關最低保價買單將被撤銷。",
  beAbouttoAlipay: "即將開搶",
  atOnceAlipay: "立即搶購",
  atOnceAlipayNew: "立即助力",
  atOnceAlipayed: "您已搶購，請關注下一輪",
  atOnceAlipayedOver: "您已搶購，不能再次搶購",
  atOnceAlipayedNew: "您已助力，請關注下一輪",
  atOnceAlipayedNewOver: "您已助力，不能再次參與",
  website: "網站",
  whitePaper: "白皮書",
  foreshow: "搶購預告",
  startToUp: "開始搶購",
  startToUpNew: "開始助力",
  distanceStartToUp: "距離開搶",
  num: "現時累計（[*]）人搶到（[**] BAT）",
  bannerText: "[*]搶到[**]額度",
  bannerTextNew: "[*] 助力[**]額度",
  nextProject: "您的額度已搶完，請關注下一個項目",
  timesText: "本輪全部搶完，下一輪[*]月[**]日[***]:[****]:[*****]準時開搶",
  times: "[*] 日 [**] 時 [***] 分 [****] 秒",
  viewDetail: "查看詳情",
  completePawd: "完成帳戶交易密碼設置",
  sureCoins: "確保持倉大於[*] [**]（最低購買量）",
  sureBalance: "確保帳戶中[*]的餘額大於[**]",
  set: "去設置",
  available: "可搶額度",
  holding: "帳戶持倉",
  startSoon: "搶購即將開始",
  startSoonNew: "助力即將開始",
  projectSupp: "專案額度",
  projectSuppNew: "助力上限",
  successBuy: "成功搶購",
  successBuyNew: "成功助力",
  projectLimit: "據專案開始還剩",
  subscription: "已成功搶購",
  subscriptionNew: "已成功助力",
  projectGoal: "此项目搶購总額度",
  projectGoalNew: "此專案助力額度",
  goalFunds: "目前已完成搶購",
  goalFundsNew: "實際助力達到目標",
};

//抢购条件

const purchaseCondition = {
  q: " 且 ",
  h: " 或 ",
  cztj: "確保充值數量",
  wqyh: "限未參加相關往期活動的用戶",
  vipdj: "限VIP[*]及以上VIP等級的用戶",
  condition: "搶購條件",
  conditionNew: "助力條件",
  nameverify1: "完成中國大陸的KYC認證",
  nameverify2: "完成中國大陸以外的KYC認證",
  nameverify3: "完成BiKing KYC認證",
  login: "請登入",
  maxBuyin: "最大買入",
  verify: "去KYC驗證",
  affirm: "確保持倉度大於[*]",
  myPosition: "我的持倉",
  AmountOfAscension: "搶購額度",
  AmountOfAscensionNew: "助力額度",
  AmountOfAscensionText: "第一輪開始前7日[*]日均持倉量越大，您的搶購額度越大",
  AmountOfAscensionTime: "我的前7日[*]日均持倉",
  discount: "搶購讓利",
  vip_discount: "助力打折",
  discountText: "VIP等級越高，搶購價格越低",
  upgrade: "去陞級",
  vipUpgrade: "我的VIP",
  zled: "助力額度",
  wdzl: "我的助力",
  zlxm: "助力項目",
  mlzl: "每輪助力",
  zlmx: "助力明細",
  ccff: "初次發放",
  qgmx: "搶購明細",

  fjtj: "附加條件",
  guoji: "國籍",
  noJoin: "不支持參加",
  wancheng: "完成",
  pinggu: "《數字貨幣投資風險測評表》",
  cyhd: "參與活動",
};

// 历史项目
const historyProject = {
  rushLimit: "搶購額度",
  averagePic: "平均價格",
  averageNum: "搶購人數",
};

// 支付
const alipay = {
  alipaynum: "搶購數量",
  alipaynumNew: "助力额度",
  ShouldPay: "應支付",
  VipDiscounts: "VIP折扣",
  VipWin: "Win會員折扣",
  willOpen: "即將開放",
  actualPayment: "實際支付",
  actualPaymentNew: "本輪助力",
  importPassword: "請輸入交易密碼",
  forGetPassword: "忘記交易密碼？",
  promptlyAlipay: "立即支付",
  purchaseSuccess: "恭喜你，搶購成功",
  purchaseSuccessNew: "恭喜你，助力成功",
  purchaseError: "抱歉，搶購失敗，請刷新頁面重試",
};
// 项目详情
const projectDetails = {
  text: "確保持倉超過 [*] [**]",
  timelimitPic: "限時價",
  subscriptionLimit: "搶購額",
  subscriptionLimitNew: "助力額",
  preheat: "預熱",
  supportAbort: "保價截止",
  unlockAbort: "發放時間",
  projectIntroduction: "項目介紹",
  projectRole: "活動規則",
  rule: "搶購規則",
  ruleNew: "助力規則",
};
// 抢购结束
const purchaseOver = {
  haveSubscribed: "已搶購額度",
  schedule: "當前進度",
  Stime: "開始搶購時間",
  StimeNew: "開始助力時間",
  Etime: "結束搶購時間",
  EtimeNew: "結束助力時間",
  successText: "此項目籌款額度[*] BAT，實際籌款達到籌款目標，籌款成功！",
  success: "成功",
};
// 我的抢购
const myPurchase = {
  endUnlock: "最後一輪搶購結束解鎖",
  endUnlock2: "最後一輪搶購結束發放",
  LText: "保價期內每日解鎖",
  WText: "保價期外每日解鎖",
  unlockend: "已解鎖",
  record: "搶購詳情",
  myPurchaseName: "我參與的項目",
};

//mHeader
const mHeader = {
  sy: "首頁",
  ksjy: "快速交易",
  zyjy: "專業交易",
  c2c: "C2C交易",
  otc: "OTC交易",
  zczx: "資產中心",
  xwgg: "新聞公告",
  xwgg1: "公告",
  lc: "BiKing Earn",
  gxlc: "高息理財",
  dxjh: "FansUp!",
  fbjy: "買幣",
  dl: "登錄",
  zc: "註冊",
  jtzw: "簡體中文",
  ftzw: "繁體中文",
  english: "English",
  kr: "한국어",
  qgms: "搶購秒殺",
  xsjy: "潜力交易",
  zczgz: "資產總估值",
  yhzx: "用戶中心",
  wdgl: "委單管理",
  tc: "退出账户",
  dltq: "低流通區",
  sdgm: "闪电购买",

  // app down
  appdown: "下載APP",
  appdown1: "下載",
  biking: "BiKing APP",
  gfqb: "官方錢包",
  xzbyapp: "下載幣贏APP",
  xzbyapp2: "下載幣贏APP",
  smewm: "扫描二维码",
  xzhyqb: "下載HyperPay錢包",
  xzhyqb2: "下載HyperPay錢包",
  bbjy: "幣幣交易",
  eftjy: "ETF交易",
  hyjy: "永续合約", //'合約交易',
  byb: "賺幣",
  newPos: "HBT矿池",
  HyperPay: "HyperPay賺幣",
  hqlc: "Pos挖礦",
  newlc: "賺幣",
  dd: "訂單",
  zichan: "資産",
  zhyaq: "賬戶&安全",
  xxzx: "消息中心",
  sfyz: "身份驗證",
  wdvip: "VIP",
  apigl: "API",
  hdzx: "活動中心",
  wdhb: "我的紅包",
  flzx: "福利中心",
  bitloan: "幣貸寶",
  hyxy: "學院",
  ggjy: "杠桿交易",
  flhd: "福利活動",
  bitWin: "幣贏寶",
};

//res
const res = {
  //抢购错误提示
  seckill_project_000: "系統異常",
  seckill_project_001: "無可用項目",
  seckill_project_002: "專案資訊不存在",
  // 用户信息错误提示
  seckill_userInfo_001: "用戶不存在",
  //i18n错误提示
  i18n_no_table_001: "系統繁忙",
  //抢购记录
  seckill_record_1: "支付失敗",

  //7日持仓规则
  seckill_7days_1: "当前项目下，未查询到持仓规则",
  //钱包相关
  seckill_wallet_1: "系统繁忙",
  seckill_wallet_2: "钱包余额不足",
  seckill_wallet_3: "支付失敗",

  //项目统计
  seckill_record_count_1: "數據錯誤",
  seckill_record_count_2: "支付失敗",
  seckill_record_count_3: "支付失敗",
  //项目轮次
  seckill_rounds_1: "系统繁忙",
  seckill_rounds_2: "當前專案中，未查詢到處於搶購中的輪次",
  seckill_rounds_3: "當前專案中，未查詢到輪次資訊",
  seckill_rounds_4: "系统繁忙",
  seckill_rounds_5: "當前專案中，未查詢到指定輪次資訊",
  //项目信息
  seckill_pro_1: "未查詢到專案資訊",
  seckill_pro_2: "搶購額度小於最小購買數量",
  seckill_pro_4: "系统繁忙",

  seckill_pro_5: "项目处于非上架状态",
  //支付
  seckill_pay_1: "系统繁忙",
  seckill_pay_2: "系统繁忙",
  seckill_pay_3: "未查詢到專案資訊",
  seckill_pay_4: "搶購額度小於最小購買數量",
  seckill_pay_5: "搶購額度超過本輪剩餘額度",

  seckill_pay_6: "没有抢购额度",

  seckill_pay_7: "購買額度大於搶購額度",
  seckill_pay_8: "系統繁忙",
  seckill_pay_9: "交易密碼錯誤",

  seckill_pay_10: "支付失败,请重新购买",
  seckill_pay_11: "支付失败,请重新购买",

  seckill_pay_12: "用戶資訊錯誤",
  seckill_pay_13: "支付失敗",

  seckill_pay_14: "交易密碼錯誤",
  seckill_pay_15: "系统繁忙",
  seckill_pay_16: "已抢完",
  seckill_pay_17: "抱歉，當前排隊搶購人數太多，請您重新嘗試",
  seckill_pay_18: "本輪已搶",
  seckill_pay_19: "本輪已搶完",
  seckill_pay_20: "請先登錄",
  seckill_pay_21: "請先完成實名認證",
  seckill_pay_22: "該項目僅限中國大陆KYC用戶搶購",
  seckill_pay_23: "該項目僅限非中國大陆KYC用戶搶購",
  seckill_pay_24: "交易密碼錯誤次數超限，請稍後再試",
  seckill_hold_1: "您持有的[*]數量未達參與條件，請購買後再來參與",
  // 问卷调查
  seckill_survey_submited: "您已提交過此問卷",
  seckill_survey_error: "問卷信息處理出錯",
  seckill_survey_info: "當前項目下,未查詢到該問卷信息",
};

const addContent = {
  hdjshy:'距離活動結束還有',
  qgsj: "搶購時間",
  qgsjNew: "助力時間",
  gz: "規則",
  zdjg: "最低價格",
  sq: "收起",
  qgms: "搶購秒殺",
  rgxm: "參與項目",
  bled: "本輪額度",
  dqjd: "當前進度",
  yjs: "已解鎖",
  yff: "已發放",
  qbcc: "確保持倉",
  cg: "超過",
  jxmks: "據專案開始還剩",
  ycgrg: "已成功搶購",
  cgrg: "成功搶購",
  xmed: "專案額度",
  cxmck: "此專案籌款額度",
  ckmb: "實際籌款達到籌款目標",
  ck: "籌款",
  ckxq: "查看詳情",
  kqed: "可搶額度",
  zhcc: "帳戶持倉",
  jjks: "搶購即將開始",
  mmsz: "完成帳戶交易密碼設置",
  qsz: "去設置",
  qbye: "確保帳戶中[*]的餘額大於[**]",
  zjcz: "確保持倉大於[*] [**]（最低購買量）",
  jgdb: "價格擔保，絕不破發",
  jgyh: "VIP返利，價格優惠",
  bwbj: "獨家法幣本位保價",
  bj: "[*]天保價，絕不破發",
  sybj: "[*]%收益，承諾保價",
  zk: "VIP折扣，搶到賺到",
  r: "人",
  lsxm: "歷史項目",
  bpf: "社區助力，海量福利熱浪來襲",
  syybz: "參與低門檻，有福利大家享",
  hg: "成為VIP會員，尊享更多福利",
  zgkx: "最高可享[*] [**]减免",
  vip_zgkx: "VIP等級越高，搶購總價的折扣越多。最高VIP6可享受[*][**]优惠",
  vip_zgkxNew: "VIP等級越高，助力總額的折扣越多。最高VIP6可享受[*][**]优惠",
  blsysj: "本輪剩餘時間",
  blqbqw: "本輪全部搶完",
  xyl: "下一輪",
  zskq: "準時開搶",
  bljshs: "本輪搶購結束還剩",
  zqyc: "每輪只能搶購一次，請下一輪再來搶購哦！",
  zxkf: "您沒有參與本次活動的許可權 詳詢客服",
  zqycNew: "每輪只能助力一次，請下一輪再來助力哦！",
  wed: "該項目您的可搶額度為0，請關注下一個項目",
  wedNew: "該項目您的可助力額度為0，請關注下一個項目",
  zsqg: "最少搶購額度[*][**]，請加倉後搶購",
  srmm: "請輸入交易密碼",
  smrz: "請先完成KYC實名認證",
  qszjymm: "請先去設置交易密碼",
  wenjuandiaocha: "您需要先完成調查問卷，才能參加本次活動。",
  scqgms: "幣贏粉絲狂歡節",
  hxyh: "助力幣贏社區，花樣福利享不停",
  zsqged: "最少搶購額度 [*] [**]",
  zsqgedNew: "最少助力額度[*] [**]",
  wmtj: "您持有的 [**] 數量未達參與條件，請購買後再來參與",
  qjchqg: "請加倉後搶購",
  qjchqgNew: "請加倉後助力",
  rgjg: "搶購價格",
  qqg: "搶折扣",
  wdqgjl: "我的參與記錄",
  ckxmxq: "查看項目詳情",
  t: "天",
  yr: "[*]月[**]日",
  yrz: "第[*]轮预热中",
  qgz: "第[*]轮抢购中",
  djlyjs: "第[*]轮已结束",
  dj: "VIP等级",
  xszk: "折扣比例",
  jgzked: "參與折扣額度",
  zked: "折扣額度",
  edw: "額度外按正常價格支付",
  qbcczd: "確保持倉大於1000 COINS（最低購買量）",
  qrrjcc: "7日日均持倉量",
  jlblks: "距離本輪開搶",
  jlbljs: "距離本輪結束",
  zgkqed: "最高可搶額度",
  zgkzf: "最高可支付",
  cggmsl: "您填寫的購買數量超過了您的購買數量限制",
  bzzfzxgm: "當前持倉不足支付最小購買量",
  bqzdqg: "本期活動最低搶購額度為 [*] [**]",
  zlzcLower:
    "助力最低額度為[*]，最高額度為[**]。活動結束後助力所得代幣將於5個工作日內發放至您的賬戶中。",
  zgqged: "最高搶購額度為 [*] [**]",
  yzbz: "優質幣種限時粉絲專屬折扣",
  xszkj: "折扣比例",
  zlbxsq: "主流幣限時搶",
  wks: "未開始",
  jxz: "進行中",
  qgsl: "搶購數量",
  wcydxm: "我參與的項目",
  bjq: "報價期",
  hgq: "回購期",
  qzk: "搶折扣",
  qxzl: "搶先助力贏代幣",
  ds: "助力上限",
  dhbl: "兌換比例",
  jicj: "基礎價",
  jiagzd: "最終價格在搶購開始前3小時內確定",
  zdyh: "最大優惠",
};

const hyy = {
  bkt: "不開通",
  wqdkt: "我確定開通",
  kt12: "1. 您在參與之前務必詳盡地了解數字貨幣合約交易的基本知識和相關風險以及參與衍生品交易所有關的業務規則等。",
  kt13: "2. 本風險提示書上述風險事項僅為列舉性質，未能詳盡的列明有關數字資產衍生品交易的所有風險因素，投資者參與數字資產衍生品交易投資前，還應該認真對其它可能存在風險因素有所了解和掌握。",
  kt14: "3. 我們誠摯的希望和建議投資者，從風險承受能力等自身實際情況出發，審慎的決定是否參與此合約交易，合理地配置自己的數字資產。",
  kt0: "親愛的用戶：",
  kt1: "您尚未開通合約賬戶及合約交易權限，請您仔細閱讀以下內容以後再決定是否開通：",
  kt2: "一、 您在合約市場進行交易，假如市場價格走勢對您不利導致您的倉位保證金不足時，幣贏永續合約會按照系統約定對您的倉位進行強平委託並披露強平明細。",
  kt3: "二、 您必須認真閱讀並遵守幣贏永續合約的業務規則，了解合約的機制和運行原理，了解市場的各種風險。",
  kt4: "四、 幣贏永續合約接入的是合約交易系統，用戶倉位的盈虧隨合約行情的波動而變化，當虧損較大時，亦會在合約交易系統中發生爆倉。請用戶您及時根據合約行情自行決定自己的交易行為，自負盈虧，據此，幣贏不承擔任何推定或者既定的保證責任。",
  kt5: "五	在某些極端的市場情況下，您可能會難以或無法將持有的未平倉合約平倉。例如，當你的盈利在整個合約市場中有效槓桿PnL中排位第一，且對手盤在保險基金不足以墊付其穿倉損失的情況下",
  kt6: "六、數字資產衍生品交易可能面臨一定法域內的政策監管風險，您在交易之前需在了解交易地域的政策監管背景的前提下審慎做出判斷。由於相關國家及地區法律、法規、政策的變化、合約交易所交易規則的修改、緊急措施的出台等原因，幣贏會提前披露聲明，您持有的未平倉合約可能無法繼續持有，但保證金和盈利的結餘仍會兌現",
  kt7: "七、	由於非平台方所能控制的原因，例如：地震、水災、火災等不可抗力因素或者計算機系統、通訊系統故障等，可能造成您的指令無法成交或者無法全部成交，由此導致的損失可能會由您自己承擔。",
  kt8: "八、	 “套期保值”交易同投机交易一样，同样面临价格波动引起的风险。",
  kta9: "九、	如果您沒有進行實名認證或者未綁定Google驗證，或者將賬號借給非本人操作，將可能會影響您的合約保證金的安全性。",
  kta10:
    "三、 在某些極端的市場情況下，您可能會難以或無法將持有的未平倉合約平倉。例如，當你的盈利在整個合約市場中有效槓桿PnL中排位第一，且對手盤在保險基金不足以墊付其穿倉損失的情況下。",

  kt9: "我已經仔細閱讀，並願意承擔風險",
  kt10: "開通合約賬號及合約交易權限",
  zjhz: "資金劃轉",
  ljhz: "立即劃轉",
  qx: "取消劃轉",
  khz: "可劃轉",
  qxz: "請選擇",
  bz: "幣種",
  c: "從",
  zz: "轉至",
  sl: "數量",
  qb: "全部",
  ktcg: "開通成功",
  ktsb: "開通失敗",
  hzcg: "劃轉成功",
  hzsb: "劃轉失敗",
  wyyd: "", //未勾选已经阅读提示文案
  tc: "退出",
  warning1: "請選擇幣種",
  warning2: "轉出賬戶不能為空",
  warning3: "轉入賬戶不能為空",
  warning4: "請輸入不大於可轉數量的數字",
  gb: "關閉",
  openSuccess: "您已開通合約交易",
  openSuccessTip: "請劃轉資金到合約帳戶",
  warning5: "最大保留4位小數",
  not_get_nm: "抱歉，泥碼活動已發放結束，本次劃轉未能獲得泥碼",
};

const trading = {
  gflj: '官方鏈接',
  gw: '官網',
  qkllq: '區塊瀏覽器',
  scfxsj: '首次發行時間',
  fxzl: '發行總量',
  ltzl: '流通總量',
  jy: '交易',
  sj: '市價',
  tbxx: '圖表信息',
  bzgk: '幣種概況',
  ddb: '訂單表',
  zxcj: '最新成交',

  reload: "刷新",
  socketError: "網絡錯誤，請",
  noData: "暫無數據",
  entrustorder: "盤口",
  prices: "價格",
  quantity: "數量",
  grandtotal: "累計",
  transamount: "交易額",
  time: "時間",
  available: "可用",
  limitorder: "限價",
  plancommission: "計劃委託",
  currentcommission: "委託",
  historycommission: "歷史委託",
  completecommission: "成交委託",
  funds: '資金',
  hidetrading: "隱藏其他交易對",
  morecurrentcommission: "更多當前委託",
  morehistorycommission: "更多历史委托",
  moredocommission: "更多成交委托",
  realtimetrans: "實時成交",
  myassets: "我的資產",
  detail: "詳情",
  buyin: "買入",
  sellout: "賣出",
  login: "登錄",
  transfer: "劃轉",
  recharge: "充值",
  withdrawal: "買幣",
  quickpurchase: "法幣快捷買幣",
  default: "默認",
  ordertime: "掛單時間",
  tradingpair: "交易對",
  direction: "方向",
  types: "類型",
  commissionprice: "委託價格",
  commissionnumber: "委托數量",
  dealprice: "成交均價",
  dealnumber: "成交數量",
  triggerprice: "觸發價格",
  cancelall: "全部撤單",
  averageprice: "均價",
  totalsum: "合計",
  fixedprice: "限价",
  marketprice: "市价",
  codeExpired: "二維碼已失效",
  clickRefresh: "點擊重繪",
  QRsuccessfully: "掃碼成功",
  loginInApp: "請在APP內確認登入",
  backtoQR: "返回二維碼登入",
  loginSuccess: "您已登錄成功，biking歡迎您！",
  loadingText: "載入中...",
  searchPlaceholder: "搜索",
  all: "全部",
  currency: "幣種",
  price: "最新價",
  market: "漲幅榜",
  increase: "漲幅",
  highestPrice: "最高",
  minimumPrice: "最低",
  turnover: "成交量",
  jydlb: "交易對列表",
  bzjs: "幣種介紹",
  currencyTransaction: "幣幣交易",
  leveragedTransaction: "杠桿交易",
  warning:
    "風險提示： Bitcoin Cash分叉具有極大的不確定性，交易或者投資分叉期貨代幣具有極大的風險，如果某壹條鏈缺乏礦工的支持，很可能無法存續，持有的相關代幣將有歸零風險。幣贏不為任何分叉期貨代幣的價值作出任何承諾！",
  zb: "指標",
  UpAnddown: "漲跌",
  amplitude: "振幅",
  0: "分時",
  1: "1分鐘",
  5: "5分鐘",
  15: "15分鐘",
  30: "30分鐘",
  60: "1小時",
  240: "4小時",
  3600: "1天",
  10800: "1周",
  dates: "周期：",
  password: "交易密碼",
  errorPassword: "請輸入正確交易密碼",
  worningPassword: "請輸入交易密碼",
  cancel: "取消",
  sure: "確定",
  canBuy: "可買",
  canCell: "可賣",
  withdraw: "提幣",
  otc: "OTC，法幣快速入場提現",
  enterPrice: "請輸入價格",
  sellingPrice: "賣出价",
  purchasePrice: "買入價",
  salesVolume: "賣出量",
  buyingVolume: "買入量",
  volume: "交易額",
  serviceCharge: "手續費",
  vip: "升級VIP 手續費立享折扣",
  or: "或",
  register: "註冊",
  totalPrice: "交易额不能大于",
  amountTip: "请输入正确数量",
  amountTipError: "数量不能大于",
 
  limitTrading: "限價交易",
  priceReminder: "價格提醒",
  SMSReminder: "簡訊提醒",
  loginAccount: "登錄賬戶",
  phone: "手機",
  phoneNum: "請輸入手機號碼",
  phoneTips: "请输入正确手机号码",
  email: "郵箱",
  emailNum: "請輸入郵箱",
  emailTips: "﻿请输入正确邮箱",
  aears: "请选择区号",
  passwordError: "请输入正确密码",
  passwordTips: "請輸入密碼",
  forgetPassword: "忘記密碼",
  noAccount: "沒有賬號",
  goRegister: "立即註冊",
  appsys: "APP掃一掃安全登入",
  xzapp: "下載最新APP",
  mmdl: "密码登陆",
  smdl: "扫码登陆",
  google: "谷歌验证器",
  nybd: "您已綁定",
  zqyzm: "请输入正确验证码",
  fsyzm: "發送驗證碼",
  flv: "費率",
  jz: "淨值",
  jzdesc1:
    "看多淨值=上個調整時點的淨值*[1+3*(現貨最新成交價-現貨上個調整時點價格)/現貨上個調整時點價格*100%]；",
  jzdesc2:
    "看空淨值=上個調整時點的淨值*[1-3*(現貨最新成交價-現貨上個調整時點價格)/現貨上個調整時點價格*100%]；",
  sbd: "三倍多",
  sbs: "三倍少",
  flvjs:
    'ETF資金費率，是平台每日對槓桿收取相應比例的管理費，來支付基金組合產生的資金費率。管理費會體現在淨值變化種，即會以"扣除相應槓桿ETF的價值"的方式呈現，且僅在新加坡時間0點收取，如果不在該時間點持有產品即不會產生費用。',
  mzsm: "免責聲明",
  ido: "我已閱讀並同意",
  exemption1: "尊敬的客户，您好！",
  exemption2:
    "感謝您登陸並使用幣贏平台（BiKing.ai）提供的公幹ETF產品和相關服務（以下簡稱“ETF產品”）。請你仔細閱讀ETF產品說明和如下風險提示，您在閱讀後繼續使用ETF產品，即視為您已經完全了解並理解ETF產品的風險，能夠承擔使用ETF產品可能帶來的損失，並視為您同意本免責聲明的全部內容。請點擊閱讀ETF產品說明：",
  exemption3: "《槓桿ETF產品FAQ》",
  exemption4: "風險提示：",
  exemption5:
    "1.您購買/出售的價格不應該較單位淨值有較大的偏差，不然您會蒙受相应的損失。",
  exemption6: "2.如果方向判斷錯誤，在極端行情下會存在價格趨近於歸零的風險。",
  exemption7:
    "幣贏平台在此鄭重的提醒您，因上述風險導致的損失或責任，均由您自行承擔，幣贏平台對此不承擔任何責任。本免責聲明與幣贏平台內的其他協議、聲明、規則等一起，構成幣贏平台與您就幣贏平台的服務和產品所達成的全部合意。",
  bzjs1: "1、“3L”表示標的交易對價格上漲1%，該產品淨值上漲3%",
  bzjs2: "2、“3S”表示標的交易對價格下跌1%，該產品淨值上漲3%",
  bzjs3: "3、淨值正常每天0點進行調整，極端行情會在盤中進行調整",
  bzjs4: "4、每倍槓桿將按天收取相應的管理費用",
  bzjs5:
    "5、交易前請注意查看淨值，該產品在極端行情下會存在價格趨近於歸零，價格遠遠偏離淨值的風險，請投資者註意控制風險",
  gdjk: "更多詳情請查看公告",
  firstTrading: "初次交易前，請先設定交易密碼",
  status: "狀態",
  status1: "待撮合",
  status2: "未成交",
  status3: "用戶撤銷",
  status4: "部分成交",
  status5: "完全成交",
  status6: "無效",
  allCancel: "批量撤銷全部委單",
  canceld: "撤單",
  cancelsuccess: "全部撤單成功,已撤[*]條委單",
  VIP1: "您的等級VIP",
  VIP2: "更為低廉的交易手續費用，更為優質的交易體驗",
  VIP3: "Taker(吃單)：",
  VIP4: "Maker(掛單)：",
  buyAmount: "買入數量不能高於",
  sellAmount: "賣出數量不能高於",
  buyAmountMin: "您的可買餘額不足",
  sellAmountMin: "您的可賣餘額不足",
};

const common = {
  wan: "萬",
  qian: "千",
  yi: "億",
};

const transferDialog = {
   amountLowTipError: "数量不能小于",
  划转: "劃轉",
  资金互转: "資金互轉",
  币币账户: "幣幣賬戶",
  买币账户: "買幣賬戶",
  已冻结: "已凍結",
  合约账户: "合約賬戶",
  未开通: "未開通",
  杠杆账户: "杠桿賬戶",
  币贷宝账户: "幣貸寶賬戶",
  从: "從",
  转至: "轉至",
  币种: "幣種",
  数量: "數量",
  全部: "全部",
  用户未归还借贷的情况下: "用戶未歸還借貸的情況下，風險率大於200%的資金可轉出",
  可划转: "可劃轉",
  一阶: "1、一阶",
  累计净划入: "累计净划入",
  可获得: "可获得",
  泥码: "泥碼",
  二阶: "2、二阶",
  您尚未完成实名认证: "您尚未完成實名認證",
  余额: "餘額",
  立即划转: "立即劃轉",
  资产划转: "資產劃轉",
  用于维持现有仓位的保证金: "用於維持現有倉位的保證金",
  归还数量: "歸還數量",
  您的币贷宝账户尚未开通: "您的幣貸寶賬戶尚未開通，請先開通",
  请输入正确的数量: "請輸入正確的數量",
  划转金额不能为: "劃轉金額不能為0",
  账户可用余额不足: "賬戶可用余額不足",
  划转失败: "劃轉失敗",
  划转成功: "劃轉成功",
  本次划转未能获得泥码: "抱歉，泥碼活動已發放結束，本次劃轉未能獲得泥碼",
  您只需再向合约账户划转: "您只需再向合約帳戶劃轉[*] USDT便能獲得[**] USDT泥碼",
  您向合约账户: "您向合約帳戶<br/>累計淨劃轉[*]USDT以上，獲得",
  请输入划转数量: "請輸入劃轉數量",
};

export {
  state,
  purchase,
  subheader,
  purchaseCondition,
  historyProject,
  alipay,
  projectDetails,
  purchaseOver,
  myPurchase,
  mHeader,
  res,
  addContent,
  hyy,
  trading,
  common,
  transferDialog,
};



// WEBPACK FOOTER //
// ./src/i18n/lang/tw.js